import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: 'emergency-response'
  });

  return (
    <div {...blockProps}>
      <div className="emergency-response-content">
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
